import { ajax as request } from '@blade/common';
export const getZoneParams = () => request({
    url: '/api/user-management/api/v1/ums/tenant/conf/zone/parameter/query',
    method: 'POST',
    data: {},
});
export const setZoneParams = (data) => request({
    url: '/api/user-management/api/v1/ums/tenant/conf/zone/parameter/update',
    method: 'POST',
    data,
});
export const getParamTime = () => request.get('/api/user-management/api/v1/ums/tenant/conf/zone/parameter/query');
export const updateParamTime = (data) => request.post('/api/user-management/api/v1/ums/tenant/conf/zone/parameter/update', data);
